// extracted by mini-css-extract-plugin
export default {"load":"loading_load__2lJGx"};